// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {VueGlobal} from '@/global'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import htmlToPdf from './utils/htmlToPdf'
import md5 from 'js-md5'
Vue.use(ElementUI)
Vue.use(htmlToPdf)
Vue.prototype.$md5 = md5
Vue.config.productionTip = false

let global = new VueGlobal()
window.$global = global

// 定义混入变量
Vue.mixin({
  data () {
    return {
      global: window.$global
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js